/* eslint-disable import/prefer-default-export */
// export const myGetter = (state) => {
//      return something
// }

export const getBrands = state => state.brands
